import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import LookupSelect from "@/components/forms/LookupSelect";
import { useLookups } from "@/contexts/LookupsContext";

export default function OfferFilters({ filters, onChange, onReset }) {
  const { t } = useTranslation();
  const lookups = useLookups();
  if (!lookups) return null;

  const set = (field, value) => onChange({ ...filters, [field]: value });

  return (
    <div className="bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="offer-filters-panel">
      <LookupSelect options={lookups.countries} value={filters.country} onChange={(v) => set("country", v)}
                    labelPrefix="lookups.countries" placeholder={t("search.filterCountry")} testId="offer-filter-country-select" />
      <LookupSelect options={lookups.regions_by_country[filters.country] || []} value={filters.region} onChange={(v) => set("region", v)}
                    labelPrefix="lookups.regions" placeholder={t("search.filterRegion")} testId="offer-filter-region-select" />
      <LookupSelect options={lookups.mission_types} value={filters.mission_type} onChange={(v) => set("mission_type", v)}
                    labelPrefix="lookups.missionTypes" placeholder={t("search.filterMission")} testId="offer-filter-mission-select" />
      <LookupSelect options={lookups.housing_options} value={filters.housing} onChange={(v) => set("housing", v)}
                    labelPrefix="lookups.housingOptions" placeholder={t("search.filterHousing")} testId="offer-filter-housing-select" />
      <LookupSelect options={lookups.languages} value={filters.language} onChange={(v) => set("language", v)}
                    labelPrefix="lookups.languages" placeholder={t("search.filterLanguage")} testId="offer-filter-language-select" />
      <LookupSelect options={lookups.permits} value={filters.permit} onChange={(v) => set("permit", v)}
                    labelPrefix="lookups.permits" placeholder={t("search.filterPermit")} testId="offer-filter-permit-select" />
      <Input type="number" placeholder={t("search.filterSalaryMin")} value={filters.salary_min || ""}
             onChange={(e) => set("salary_min", e.target.value)} className="h-12 rounded-xl bg-[#FAFAFA] border-black/10" data-testid="offer-filter-salary-min-input" />
      <Button variant="outline" onClick={onReset} className="h-12 rounded-xl" data-testid="offer-filter-reset-button">
        {t("common.resetFilters")}
      </Button>
    </div>
  );
}
